module.exports = __webpack_public_path__ + "img/icon-plane.b4afd21a.svg";